/**
 * Maps Amazon amzn.to shortlinks to their resolved ASINs so the affiliate
 * card renderer can enrich products whose hrefs haven't been rewritten to
 * direct /dp/<ASIN>/ form yet.
 *
 * Populate by resolving shortlinks once (via `curl -sI <shortlink>` and
 * reading the Location header) — don't resolve at render time.
 *
 * To rebuild for a slug:
 *   1. Grep the post's content for amzn.to hrefs
 *   2. curl -sI each to get the redirect target
 *   3. Extract the ASIN (/dp/<ASIN>/) and add a line here
 */

export const SHORTLINK_TO_ASIN: Record<string, string> = {
  // long-scotts-weed-feed-take-work
  'https://amzn.to/3NBZ9aO': 'B00XJM8KMQ', // Scotts Turf Builder Weed and Feed 3
  'https://amzn.to/41z6UBt': 'B09JVFT7N5', // Scotts Turf Builder Triple Action (non-Southern despite anchor text)
  // Herbicide timing tool — post-emergent pilot
  'https://amzn.to/4c8gmlr': 'B0058V1IV6', // 2,4-D Amine Selective Herbicide
  'https://amzn.to/4bU6JWn': 'B015BSWOV8', // Trimec Classic
  'https://amzn.to/4s6vpAV': 'B001PCRKDC', // SpeedZone Broadleaf
  // Scotts cluster expansion — blog affiliate block pilot
  'https://amzn.to/3OansN9': 'B07NZ2BMMK', // Andersons Barricade Professional-Grade Prodiamine
  'https://amzn.to/3Pw76Pr': 'B000UGU59K', // Scotts Turf Builder Southern Lawn Food
  'https://amzn.to/4tfOT75': 'B09FYVJL56', // Greenworks Corded Electric Dethatcher
  'https://amzn.to/3OQBpje': 'B0050DV4ZW', // Scotts GrubEx1 (already enriched via article-product-picks.ts)
  'https://amzn.to/4cfTL73': 'B001PCRKDC', // Gordon's SpeedZone (alt shortlink for already-enriched ASIN)
  'https://amzn.to/4rCK2fO': 'B005DUTNF0', // Syngenta Tenacity (already enriched via guide-product-recommendations.ts)
  // Herbicide timing tool — pre-emergent + post-emergent images for the
  // FeaturedProductCard / CompactProductCard renderers.
  'https://amzn.to/4bCyrIb': 'B015BSNZP2', // Prodiamine 0-0-7 (Quali-Pro Prodiamine 65 WDG)
  'https://amzn.to/4bF2Ohf': 'B0051GXXPW', // Dimension 2EW
  'https://amzn.to/4bEp9vo': 'B00OXD2CKG', // Barricade 4FL (Syngenta)
  'https://amzn.to/4lSgk4k': 'B09SBR4BBR', // Tenacity Herbicide (resolves to Atticus Torocity, mesotrione equivalent)
  'https://amzn.to/4dgQB3p': 'B09NCJ2ZXQ', // Glyphosate non-selective (resolves to Roundup for Lawns₂ Concentrate)
  'https://amzn.to/4cbwVwP': 'B006LAVM3W', // Quinclorac 75DF (Quali-Pro)
  // Grass guides + low-maintenance/fast-growing/high-traffic blog cluster
  'https://amzn.to/4cmh9Qj': 'B003AYWIU8', // Jonathan Green 10322 Black Beauty Ultra Grass Seed
  'https://amzn.to/4bhgUVG': 'B07SYLCKRH', // Andersons PGF Complete 16-4-8 Fertilizer
  'https://amzn.to/3OFcO0S': 'B0DDHTJKCY', // Milorganite Recycled Nitrogen Fertilizer
  'https://amzn.to/47vcjNq': 'B077SXJDJP', // Scotts Turf Builder Thick'R Lawn Sun and Shade
  'https://amzn.to/3PH4Dl4': 'B08QCNV9ZV', // Pennington Smart Seed Sun and Shade Mix
  'https://amzn.to/4aZLWQG': 'B075R7BNXV', // Scotts DiseaseEx Lawn Fungicide
}

export function resolveShortlinkAsin(href: string): string | null {
  return SHORTLINK_TO_ASIN[href] ?? null
}
